var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useHostValue } from "../Contexts/HostContext";
import { filterHosts } from "../Helper/HostListSorter";
import HostPositioner from "./HostPositioner";
import { forceCheck } from "react-lazyload";
import { useRect } from "../CustomHooks/useRect";
function HostGrid(_a) {
  var page = _a.page;
  var _b = useState(false),
    animated = _b[0],
    setAnimated = _b[1];
  var state = useHostValue()[0];
  var holder = useRef();
  var rect = useRect(holder);
  var cardWidth = 240;
  if (window.layoutSettings.layout.pictureSize === "big") {
    cardWidth = 300;
  }
  var holderWidth = rect.width;
  var columns = Math.floor(holderWidth / (cardWidth + 2));
  if (columns < 1) {
    columns = 1;
  }
  // Special case
  if (holderWidth >= 360 && holderWidth <= 490) {
    columns = 2;
  }
  var rows = 5;
  if (columns < 3) {
    rows = 10;
  }
  var pageSize = columns * rows;
  var currentHosts = filterHosts(state.hosts).slice(pageSize * (page - 1), pageSize * page);
  var mapped = currentHosts.map(function (child, index) {
    var spaceBetween = (holderWidth - columns * cardWidth) / (columns - 1);
    var left = (cardWidth + spaceBetween) * (index % columns);
    if (columns === 2) {
      left = cardWidth * (index % columns) + Math.floor(spaceBetween / 3) * (index % columns + 1);
    }
    if (holderWidth >= 360 && holderWidth <= 490) {
      left = (holderWidth / 2 + 2) * (index % columns);
    }
    if (columns === 1) {
      left = 3;
    }
    var top = 405 * Math.floor(index / columns);
    return __assign(__assign({}, child), {
      left: left,
      top: top
    });
  });
  var renderedHosts = mapped.map(function (item) {
    return /*#__PURE__*/React.createElement(HostPositioner, {
      key: item.id,
      host: item
    });
  });
  // Only animate hosts after three seconds to keep starting screen from moving
  useEffect(function () {
    setTimeout(function () {
      setAnimated(true);
    }, 3000);
  }, []);
  // Force image lazyload checking every time the hosts change
  useEffect(function () {
    var timer = setTimeout(forceCheck, 500);
    return function () {
      return clearTimeout(timer);
    };
  }, [renderedHosts]);
  return /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center gridreplace l-container h-center",
    id: "senderList"
  }, /*#__PURE__*/React.createElement("div", {
    ref: holder,
    className: "senders c-host-grid" + (animated ? ' animated' : ''),
    style: {
      height: rows * 409 + "px"
    }
  }, renderedHosts));
}
export default HostGrid;